import axios from 'axios';
import { cachetime } from '../config';

export default function() {
  return {
    namespaced: true,
    state: {
      representatives: {},
    },
    mutations: {
      SET_REPRESENTATIVES(state, { data, locale }) {
        state.representatives = {
          ...state.representatives,
          [locale]: {
            data,
            __updatedAt: Date.now(),
          }
        }
      }
    },
    actions: {
      FETCH_REPRESENTATIVES({ state, commit }, { locale }) {
        if (state.representatives[locale] 
          && state.representatives[locale].data
          && Date.now() - state.representatives[locale].__updatedAt < cachetime
        ) {
          return ;
        }

        return axios.get('/api/representatives')
          .then((res) => {
            const data = res.data || {};
            commit('SET_REPRESENTATIVES', { data, locale});
          }).catch(err => console.log(err));
      }
    },
    getters: {
      getRepresentatives: (state) => (locale) => {
        return state.representatives[locale] ? state.representatives[locale].data || {} : {};
      }
    }
  }
};